import React from 'react';

export type PressedKeysContextValue = {
  isKeyPressed: (key: string) => boolean;
  subscribeToKey: (key: string, listener: (isPressed: boolean) => void) => () => void;
};

export const PressedKeysContext = React.createContext<PressedKeysContextValue | null>(null);
